// Elenchi di MIME type accettati lato client, allineati esattamente a ciò che ogni
// endpoint PHP valida lato server (vedi $allowed_mime / $allowed_mimes nei rispettivi file).

// guest_attachments.php, user_details.php, pagamenti.php, volunteer_documents.php
export const DOCUMENT_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

// announcements.php, communications.php (non accettano image/webp)
export const DOCUMENT_MIME_TYPES_NO_WEBP = DOCUMENT_MIME_TYPES.filter((m) => m !== 'image/webp');

// turni.php (allegati ferie/permesso), diario.php (non accettano file Excel)
export const DOCUMENT_MIME_TYPES_NO_SPREADSHEET = DOCUMENT_MIME_TYPES.filter(
    (m) => m !== 'application/vnd.ms-excel' && m !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
);
